<template>
    <div class="dvgraficoline">
        <v-chart :options="options"/>
    </div>
</template>
<style>
</style>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/lines'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

import 'echarts/theme/dark'

export default {
    name : "cmpgraficoline",
    components: {
        'v-chart': ECharts
    },
    props:[		
        'titulo',
        'agrupamento',
        'legendas',
		    'dados'
    ],
    data () {
        return {
            options : {
            
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: []
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            toolbox: {
            },
            xAxis: {
      
             
              data: []
            },
            yAxis: {
              type: 'value'
            },
            series: []
            }
        }
    },
    mounted: function () {         
    },    
    computed:{
    },
    watch:{
       dados(){
            this.options.xAxis.data  			   = this.agrupamento;
			      this.options.series              = this.dados;			
            this.options.legend.data         = this.legendas;			

        }
    }    
}
</script>